import {
  AboutApp,
  EdDepAbout,
  EdDepAdmin,
  MapViewAdmin,
  PopoverStudentTeacherDetails,
  JobOpeningsMap,
  MapNavigation,
  EdDepInfoNav,
  PictureWallNav,
  resetToggles,
} from "components";
import { HandshakeCareersContext, MappableContext, CuratedContext } from "contexts";
import React, { useContext, useState, useEffect } from "react";
import { Redirect, Route, Switch, useHistory, useLocation } from "react-router-dom";
import { useIdleTimer } from "react-idle-timer";
import { URLPaths } from "utilities";
import { AnimatePresence } from "framer-motion";
import { MapViewToggle } from "./MapView/MapViewToggle";
import { EdDepInfo } from "./pages/EdDepInfoPage";
import { PictureWall } from "./pages/PictureWallPage";
import { AdminMayTermStoryDetails } from "./pages/AllStoryDetails/AdminMayTermStoryDetails";
import { AdminStudentTeacherStoryDetails } from "./pages/AllStoryDetails/AdminStudentTeacherStoryDetails";
import { AdminPartnerSchoolStoryDetails } from "./pages/AllStoryDetails/AdminPartnerSchoolStoryDetails";
import { AdminFacultyStoryDetails } from "./pages/AllStoryDetails/AdminFacultyStoryDetails";
import { AdminHiredPlacementStoryDetails } from "./pages/AllStoryDetails/AdminHiredPlacementStoryDetails";
import { PictureWallStudentTeacherStoryDetails } from "./pages/AllStoryDetails/PictureWallStudentTeacherStoryDetails";
import { PopoverMayTermDetails } from "./pages/AllStoryDetails/PopoverMayTermDetails";
import { PopoverPartnerSchoolDetails } from "./pages/AllStoryDetails/PopoverPartnerSchoolDetails";
import { PictureWallFacultyStoryDetails } from "./pages/AllStoryDetails/PictureWallFacultyStoryDetails";
import { PopoverHiredPlacementDetails } from "./pages/AllStoryDetails/PopoverHiredPlacementDetails";

export const variants = {
  center: {
    opacity: 1,
    x: 0,
    zIndex: 1,
  },
  enter: {
    opacity: 1,
    x: 1000,
    zIndex: 1,
  },
  exit: {
    opacity: 0.99,
    x: 0,
    zIndex: -10,
  },
  jobcenter: {
    opacity: 1,

    zIndex: 1,
  },
  jobenter: {
    duration: 0.2,
    opacity: 1,
    zIndex: 1,
  },
  jobexit: {
    opacity: 0,

    zIndex: -10,
  },
};

export default function AnimatedRoutes(): JSX.Element {
  const history = useHistory();

  const timeout = 1000 * 180;
  // eslint-disable-next-line
  const [remaining, setRemaining] = useState(timeout);

  const handleOnIdle = () => {
    // SHOW YOUR MODAL HERE AND LoGOUT
    console.log("The user has been logged out...");
    resetToggles();
    console.log("The map toggles have been reset");
    history.push("/picture-wall");
  };

  const { getRemainingTime } = useIdleTimer({
    onIdle: handleOnIdle,
    timeout,
  });

  useEffect(() => {
    setRemaining(getRemainingTime());

    setInterval(() => {
      setRemaining(getRemainingTime());
    }, 1000);
    // eslint-disable-next-line
  }, []);

  const { items: handshakeCareers, isLoading: isHandshakeCareersLoading } =
    useContext(HandshakeCareersContext);
  const { items: Curated, isLoading: isCuratedLoading } = useContext(CuratedContext);
  const { items: Mappable, isLoading: isMappableLoading } = useContext(MappableContext);
  // eslint-disable-next-line
  const [mapZoom, setMapZoom] = useState(8);
  const [keyVal, setkeyVal] = useState<"true" | "false">("true");
  // eslint-disable-next-line
  const [defaultCenter, setDefaultCenter] = useState<{
    lat: number;
    lng: number;
  }>({
    lat: 42.870859,
    lng: -83.865036,
  });

  const location = useLocation();
  return (
    <div>
      <AnimatePresence>
        <Switch location={location} key={location.pathname}>
          <Route exact path={URLPaths.mapViewAdmin}>
            <MapNavigation
              keyVal={keyVal}
              toggleMap={setkeyVal}
              setMapZoom={setMapZoom}
              setDefaultCenter={setDefaultCenter}
            />
            <JobOpeningsMap background />
            <MapViewAdmin />
          </Route>

          <Route exact path={URLPaths.map}>
            <MapViewToggle data={Mappable} isLoading={isMappableLoading} defaultZoom={8} />
            <AboutApp />
          </Route>

          <Route exact path={URLPaths.pictureWall}>
            <PictureWallNav />
            <PictureWall data={Curated} isLoading={isCuratedLoading} />
          </Route>

          <Route exact path={URLPaths.edDepInfo}>
            <EdDepInfoNav />
            <EdDepInfo />
            <EdDepAbout />
          </Route>

          <Route exact path={URLPaths.edDepInfoAdmin}>
            <EdDepInfoNav />
            <EdDepAdmin />
          </Route>

          <Route exact path={`${URLPaths.mapViewAdmin}/student-teacher-details/:id`}>
            <MapNavigation
              keyVal={keyVal}
              toggleMap={setkeyVal}
              setMapZoom={setMapZoom}
              setDefaultCenter={setDefaultCenter}
            />
            <AdminStudentTeacherStoryDetails />
          </Route>

          <Route exact path={`${URLPaths.mapViewAdmin}/hired-placement-details/:id`}>
            <MapNavigation
              keyVal={keyVal}
              toggleMap={setkeyVal}
              setMapZoom={setMapZoom}
              setDefaultCenter={setDefaultCenter}
            />
            <AdminHiredPlacementStoryDetails />
          </Route>

          <Route exact path={`${URLPaths.mapViewAdmin}/faculty-details/:id`}>
            <MapNavigation
              keyVal={keyVal}
              toggleMap={setkeyVal}
              setMapZoom={setMapZoom}
              setDefaultCenter={setDefaultCenter}
            />
            <AdminFacultyStoryDetails />
          </Route>

          <Route exact path={`${URLPaths.mapViewAdmin}/may-term-details/:id`}>
            <MapNavigation
              keyVal={keyVal}
              toggleMap={setkeyVal}
              setMapZoom={setMapZoom}
              setDefaultCenter={setDefaultCenter}
            />
            <AdminMayTermStoryDetails />
          </Route>

          <Route exact path={`${URLPaths.mapViewAdmin}/partner-school-details/:id`}>
            <MapNavigation
              keyVal={keyVal}
              toggleMap={setkeyVal}
              setMapZoom={setMapZoom}
              setDefaultCenter={setDefaultCenter}
            />
            <AdminPartnerSchoolStoryDetails />
          </Route>

          <Route exact path={`${URLPaths.map}/popover-student-teacher-details/:id`}>
            <MapNavigation
              keyVal={keyVal}
              toggleMap={setkeyVal}
              setMapZoom={setMapZoom}
              setDefaultCenter={setDefaultCenter}
            />
            <JobOpeningsMap background />
            <PopoverStudentTeacherDetails />
          </Route>

          <Route exact path={`${URLPaths.map}/popover-hired-placement-details/:id`}>
            <MapNavigation
              keyVal={keyVal}
              toggleMap={setkeyVal}
              setMapZoom={setMapZoom}
              setDefaultCenter={setDefaultCenter}
            />
            <JobOpeningsMap background />
            <PopoverHiredPlacementDetails />
          </Route>

          <Route exact path={`${URLPaths.map}/popover-may-term-details/:id`}>
            <MapNavigation
              keyVal={keyVal}
              toggleMap={setkeyVal}
              setMapZoom={setMapZoom}
              setDefaultCenter={setDefaultCenter}
            />
            <JobOpeningsMap background />
            <PopoverMayTermDetails />
          </Route>

          <Route exact path={`${URLPaths.map}/popover-partner-school-details/:id`}>
            <MapNavigation
              keyVal={keyVal}
              toggleMap={setkeyVal}
              setMapZoom={setMapZoom}
              setDefaultCenter={setDefaultCenter}
            />
            <JobOpeningsMap background />
            <PopoverPartnerSchoolDetails />
          </Route>

          <Route exact path={`${URLPaths.pictureWall}/picture-wall-student-teacher-details/:id`}>
            <PictureWallNav />

            <PictureWallStudentTeacherStoryDetails />
          </Route>

          <Route exact path={`${URLPaths.pictureWall}/picture-wall-faculty-details/:id`}>
            <PictureWallNav />

            <PictureWallFacultyStoryDetails />
          </Route>

          <Route exact path={URLPaths.jobOpeningsFinder}>
            <MapNavigation
              keyVal={keyVal}
              toggleMap={setkeyVal}
              setMapZoom={setMapZoom}
              setDefaultCenter={setDefaultCenter}
            />
            <AboutApp />
            <JobOpeningsMap data={handshakeCareers} isLoading={isHandshakeCareersLoading} />
          </Route>

          <Route exact path={URLPaths.searchPage}>
            <MapNavigation
              keyVal={keyVal}
              toggleMap={setkeyVal}
              setMapZoom={setMapZoom}
              setDefaultCenter={setDefaultCenter}
            />
            <AboutApp />
          </Route>

          <Route exact path={URLPaths.map}>
            <MapViewToggle data={Mappable} isLoading={isMappableLoading} defaultZoom={10} />
            <AboutApp />
          </Route>

          <Redirect to={URLPaths.edDepInfo} />
        </Switch>
      </AnimatePresence>
    </div>
  );
}
